<template>
  <div class="text-center pa-4 supportPage" style="background: #f8fafc none repeat scroll 0 0; padding: 25px 50px 50px 50px !important;">
    <v-row class="">
      <v-col cols="6" style="color: #0d0d60;
        font-size: 1.5rem !important;
        font-weight: 800 !important; text-align: left;">
        Activities
      </v-col>
      <v-col cols="6" style="text-align: right;">
        <v-btn @click="toggleDrawer" class="btn-soft-success" style="margin: 3.5px;" >
                <v-badge
                  v-if="selectedFilterStatus || selectedFilterPriority"
                  :content="badgeCount"
                  color="#10b981" 
                  overlap
                  style="bottom: 20px;left:90px;"
                >
                </v-badge><span class="mdi mdi-filter-outline" style="font-size: 20px;"></span>
                Filters
              </v-btn>
      </v-col>
    </v-row>
    <div class="d-flex align-center table-top" style="     margin-bottom: 20px;">
  <!-- Left side -->
  <v-spacer></v-spacer>
  <div class="d-flex align-center am-table-title" style="padding-right: 5px;">
    <span>Rows per page:</span>
    <v-select
      :items="[10, 20, 30]"
      v-model="pagination.rowsPerPage"
      @change="changeRowsPerPage()"
      hide-details
      dense
      outlined
      style="max-width: 80px; min-width: 60px; margin-left: 8px;"
      :menu-props="{ maxHeight: '150px',top: false, offsetY: true }"
      class="pa-0"
    />
  </div>

  <!-- Right side -->
  <div class="d-flex align-center">
    <button
      :disabled="pagination.page === 1"
      @click="pagination.page = pagination.page - 1; getAllTickets()"
      class="mx-1 right-side"
    >
      <i class="fa fa-chevron-left" style="color: grey;"></i>
    </button>
   <div class="d-flex align-center">
  <span>Page:</span>
  <input
  v-model.number="pagination.page"
  type="number"
  :min="1"
  :max="pagination.length"
  @change="validatePage"
  style="
    max-width: 40px;
    text-align: center;
    margin: 5px;
    flex: 1;
    background-color: transparent;
    color: black;
    border-radius: 4px;
    padding: 0 5px;
    border: 1px solid lightgray;
  "
/>

<span class="ml-2">/ {{ pagination.length }}</span>
</div>

    <button
      :disabled="pagination.page === pagination.length"
      @click="pagination.page++; getAllTickets()"
      class="mx-1 right-side"
    >
      <i class="fa fa-chevron-right" style="color: grey;"></i>
    </button>
  </div>
</div>
    <div class="employee-lists" style="    border-radius: 24px;
    overflow: hidden;">
        <div class="table-wrapper">
          <table class="emp-table" fixed-header style="overflow-x:auto; border-collapse: collapse;">
            <thead>
              <tr style="border-bottom: 1px solid lightgray;background-color: #f3f6f9 !important;">
                <th class="sticky-col am-table-title header-cell text-left" style="background-color: #c5c5d8 !important;">
                  <div class="d-flex">
                    <div style="width: 60px;">
                      S.No
                    </div>
                    <div style="width: 150px;">
                      Ticket ID
                    </div>
                    <div style="width: 300px;">
                      Ticket Details
                    </div>
                  </div>
                </th>
                <th class="am-table-title header-cell text-left" style="min-width: 180px;">Created By</th>
                <th class="am-table-title header-cell text-left" style="min-width: 180px;">Company</th>
                <th class="am-table-title header-cell text-left"  style="min-width: 180px;">Deadline</th>
                <th class="am-table-title header-cell text-left" style="min-width: 180px;">Status</th>
                <th class="am-table-title header-cell text-left" style="width: 250px;">Assigned To</th>
                <th class="am-table-title header-cell text-left" style="min-width: 180px;">Priority</th>
                <th class="am-table-title header-cell text-left" style="min-width: 180px;">Created At</th>
                <th class="sticky-col1 am-table-title header-cell" style="width: 3.3333%;background: #c5c5d8 !important;"></th>
              </tr>
            </thead>
            <tbody style="background-color: white; ">
              <tr v-for="(e, index) in tickets" :key="index" style="border-bottom: 1px solid #f0f0f0;">
                <td class="sticky-col" style="width: 28.3333%;z-index: 2; padding: 16px;">
                    <div class="d-flex" style="align-items: center;">
                    <div style="width: 60px;" class="am-table-title text-left">
                      {{ (pagination.page - 1) * pagination.rowsPerPage + index + 1 }} 
                    </div>
                    <div style="width: 150px;" class="am-table-title text-left">
                      {{ e.ticket_id }}
                    </div>
                    <div style="width: 300px;">
                      <div class="emp-action align-self-center text-left" style="">
                    <div class="emp-desc-wrap" style="cursor:pointer;">
                      <div class="emp-desc">
                        <div class="emp-name hover-link cursor-pointer am-table-title">
                          <span class="am-table-title truncate-text" v-if="e.subject" :title="e.subject">{{e.subject}}</span>
                          <span v-else>--</span>
                        </div>
                        <div class="emp-email am-table-sub-title">
                            <span class="am-table-sub-title truncate-text " v-if="e.description" :title="e.description">{{ e.description }}</span>
                          <span v-else>--</span>
                        </div>
                      </div>
                    </div>
                  </div>
                    </div>
                  </div>
                </td>
                <td style="width: 180px;" class="text-center">
                  <div class="emp-action align-self-center text-left" style="">
                    <div class="emp-desc-wrap" style="cursor:pointer;">
                      <div class="emp-desc">
                        <div class="emp-name hover-link cursor-pointer am-table-title">
                          <span class="am-table-title truncate-text" v-if="e.created_by_name" :title="e.created_by_name">{{e.created_by_name}}</span>
                          <span v-else>--</span>
                        </div>
                        <div class="emp-email am-table-sub-title">
                            <span class="am-table-sub-title truncate-text " v-if="e.created_by_email" :title="e.created_by_email">{{ e.created_by_email }}</span>
                          <span v-else>--</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
                <td style="width: 180px;"  class="text-left">
                  <div class="emp-engagement  am-table-title" v-if="e.company">
                    {{ e.company }}
                  </div>
                  <div v-else>--</div>
                </td>
                <td style="width: 180px;"  class="text-left">
                  <div class="emp-engagement  am-table-title" v-if="e.deadline">
                    {{ moment(e.deadline).format('DD MMM YYYY')  }} <v-icon small class="" style="cursor: pointer;" @click="modal = true; ticketId = e.ticket_id; updateType = 'deadline'">mdi-pencil</v-icon>
                  </div>
                  <div v-else>-- <v-icon small class="ml-2" style="cursor: pointer;" @click="modal = true; ticketId = e.ticket_id; updateType = 'deadline'">mdi-pencil</v-icon></div>
                </td>
                <td style="width: 170px;"  class="text-left">
                  <div class="emp-resolution" v-if="e.status">
                    <v-menu
                      top
                      :offset-y="offset"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn :style="{ backgroundColor: getStatusColor(e.status) }" style="color: black;     text-transform: capitalize;"
                          dark rounded small
                          v-bind="attrs"
                          v-on="on"
                        >
                          {{ e.status.replace('_', '') }} <svg xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 -960 960 960" width="18px" fill="#000000"><path d="M480-344 240-584l56-56 184 184 184-184 56 56-240 240Z"/></svg>
                        </v-btn>
                      </template>

                      <v-list>
                        <v-list-item
                        v-for="(item, index) in statusList"
                              :key="index"
                              @click="selectedStatus = item.key;  assignAdminDialog = false; ticketId = e.ticket_id; updateType = 'status'; assignTicketToAdmin()"
                              style="cursor: pointer;"
                        >
                          <v-list-item-title>{{ item.label }}</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                    <!-- <v-chip small :style="{ backgroundColor: getStatusColor(e.status) }" class="am-table-title capitalize-text" style="">
                      {{ e.status.replace('_', '') }}
                    </v-chip>
                    <v-icon small class="ml-2" style="cursor: pointer;" @click="assignAdminDialog = true; ticketId = e.ticket_id; updateType = 'status'">mdi-pencil</v-icon> -->
                  </div>
                  <div v-else>--</div>
                </td>
                <td style="min-width: 220px;"  class="text-left">
                  <div class="emp-assigned  am-table-title" style="white-space: normal;" v-if="e.assigned_to_email">
                    {{ e.assigned_to_email }}
                    <v-icon small class="ml-2" style="cursor: pointer;" @click="assignAdminDialog = true; ticketId = e.ticket_id; updateType = 'assigned'">mdi-pencil</v-icon>
                  </div>
                  <div v-else>
                    --
                    <v-icon small class="ml-2" style="cursor: pointer;" @click="assignAdminDialog = true; ticketId = e.ticket_id; updateType = 'assigned'">mdi-pencil</v-icon>
                  </div>
                </td>
                <td style="min-width: 180px;"  class="text-left">
                  <div class="emp-assigned  am-table-title text-capitalize" style="white-space: normal;     height: 30px;" v-if="e.priority">
                    <v-menu
                      top
                      :offset-y="offset"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn style="color: black !important; text-transform: capitalize;"
                          dark rounded small color="primary" outlined
                          v-bind="attrs"
                          v-on="on"
                        >
                          <div :style="{ backgroundColor: getPriorityColor(e.priority) }" style="width: 10px; height: 10px;     margin-right: 5px; display: inline-block; border-radius: 50%;"></div> 
                          {{ e.priority }} <svg xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 -960 960 960" width="18px" fill="#000000"><path d="M480-344 240-584l56-56 184 184 184-184 56 56-240 240Z"/></svg>
                        </v-btn>
                      </template>

                      <v-list>
                        <v-list-item
                        v-for="(item, index) in priorityList"
                              :key="index"
                              @click="selectedPriority = item.key; assignAdminDialog = false; ticketId = e.ticket_id; updateType = 'priority'; assignTicketToAdmin()"
                              style="cursor: pointer;"
                        >
                          <v-list-item-title> <div :style="{ backgroundColor: getPriorityColor(item.key) }" style="width: 10px; height: 10px;     margin-right: 5px; display: inline-block; border-radius: 50%;"></div>  {{ item.label }}</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                    <!-- <div :style="{ backgroundColor: getPriorityColor(e.priority) }" style="width: 10px; height: 10px; display: inline-block; border-radius: 50%;"></div>
                    {{ e.priority }} <v-icon small class="ml-2" style="cursor: pointer;" @click="assignAdminDialog = true; ticketId = e.ticket_id; updateType = 'priority'">mdi-pencil</v-icon> -->
                  </div>
                  <div v-else>--</div>
                </td>
                <td style="min-width: 180px;"  class="text-left">
                  <div class="emp-assigned  am-table-title" style="white-space: normal;" v-if="e.created_at">
                    {{ moment(e.created_at).format('DD MMM YYYY') }}
                  </div>
                  <div v-else>--</div>
                </td>
                <td class="sticky-col1 text-center" style="width: 3.3333%;" >
                  <div class="sticky-col1 emp-assigned  am-table-title text-capitalize" style="white-space: normal;" v-if="e.priority">
                    <v-btn icon style="text-transform: none;" text color="primary" @click="viewData(e)">
                      <svg xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 -960 960 960" width="18px" fill="#10b981"><path d="M480-320q75 0 127.5-52.5T660-500q0-75-52.5-127.5T480-680q-75 0-127.5 52.5T300-500q0 75 52.5 127.5T480-320Zm0-72q-45 0-76.5-31.5T372-500q0-45 31.5-76.5T480-608q45 0 76.5 31.5T588-500q0 45-31.5 76.5T480-392Zm0 192q-146 0-266-81.5T40-500q54-137 174-218.5T480-800q146 0 266 81.5T920-500q-54 137-174 218.5T480-200Zm0-300Zm0 220q113 0 207.5-59.5T832-500q-50-101-144.5-160.5T480-720q-113 0-207.5 59.5T128-500q50 101 144.5 160.5T480-280Z"/></svg>
                    </v-btn>
                  </div>
                  <div v-else>--</div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
    </div>
    <v-navigation-drawer
    style="z-index: 11;"
      v-model="drawerOpen" class="filterDrawer"
      app
      right
      temporary
      width="400"
    >
  <v-list style="margin-top: 70px;">
    <v-list-item style="align-items:left">
  <v-list-item-content>
    <v-list-item-title style="font-size:20px;font-weight:600;text-align: left;">
      Company Filters
    </v-list-item-title>
    <v-list-item-title style="text-align: left;">
      Filters will be applied to Company List
    </v-list-item-title>
  </v-list-item-content>
  <v-btn @click="resetFilters" style="border:1px solid #10b981;color:#10b981;background-color: white;box-shadow: none;text-transform: capitalize;"      v-if="selectedFilterPriority || selectedFilterStatus"   >
    <span class="mdi mdi-restore"></span>
    Reset
  </v-btn>
</v-list-item>
<v-expansion-panels bg-color="white" flat style="border-bottom:1px solid #0003;border-radius:0px !important;margin-left: 1px;">
    <v-expansion-panel>
      <v-expansion-panel-header>
        Status
        <v-chip 
        v-if="selectedFilterStatus" 
        style="float: right; background-color: white;border:1px solid #10b981;color:#10b981;    max-width: fit-content;
    margin: 0 0 0 auto;">
        1 Selected
      </v-chip>
      </v-expansion-panel-header>

      <v-expansion-panel-content>
        <v-radio-group
          v-model="selectedFilterStatus"
          column
        >
          <v-radio
            v-for="status in statusList"
            :key="status.key"
            :label="status.label"
            :value="status.key"
          />
        </v-radio-group>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
<v-expansion-panels bg-color="white" flat style="border-bottom:1px solid #0003;border-radius:0px !important;margin-left: 1px;">
    <v-expansion-panel>
      <v-expansion-panel-header>
        Priority <v-chip 
        v-if="selectedFilterPriority" 
        style="float: right; background-color: white;border:1px solid #10b981;color:#10b981;    max-width: fit-content;
    margin: 0 0 0 auto;">
        1 Selected
      </v-chip>
      </v-expansion-panel-header>

      <v-expansion-panel-content>
        <v-radio-group
          v-model="selectedFilterPriority"
          column
        >
          <v-radio
            v-for="priority in priorityList"
            :key="priority.key"
            :label="priority.label"
            :value="priority.key"
          />
        </v-radio-group>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
  <!-- <v-expansion-panels bg-color="white" flat style="border-bottom:1px solid #0003;border-radius:0px !important;margin-left: 1px;">
    <v-expansion-panel>
      <v-expansion-panel-header>
        Assigned To
      </v-expansion-panel-header>

      <v-expansion-panel-content>
        <v-radio-group
          v-model="selectedFilterAssignedTo"
          column
        >
          <v-radio
            v-for="admin in adminList"
            :key="admin"
            :label="admin"
            :value="admin"
          />
        </v-radio-group>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels> -->
    <v-btn @click="applyFilters()" style="    background-color: #10b981;
    color: white;box-shadow: none;    position: absolute; text-transform: capitalize;
    bottom: 12px;
    right: 12px;">
    Apply filter
  </v-btn>
  </v-list>
    </v-navigation-drawer>
    <v-dialog
        v-model="assignAdminDialog"
        max-width="700"
        scrollable
    >
    <v-card>
      <v-card-title v-if="updateType === 'assigned'">
        Assigned ticket to
      </v-card-title>
      <v-card-title v-if="updateType === 'deadline'">
        Select deadline for ticket
      </v-card-title>
      <v-card-title v-if="updateType === 'status'">
        Select status for ticket
      </v-card-title>
      <v-card-title v-if="updateType === 'priority'">
        Select priority for ticket
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text v-if="updateType === 'assigned'">
        <v-list >
            <v-list-item
                v-for="(admin, index) in ['amit.kumar@amara.ai', 'rajat@amara.ai', 'manjot.singh@amara.ai']"
                :key="index"
                @click="selectedAdmin = admin; assignAdminDialog = false; assignTicketToAdmin()"
                style="cursor: pointer;"
            >
                <v-list-item-content>
                <v-list-item-title>{{ admin }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </v-list>
      </v-card-text>
      <v-card-text v-if="updateType === 'status'">
        <v-list >
            <v-list-item
              v-for="(item, index) in statusList"
              :key="index"
              @click="selectedStatus = item.key; assignAdminDialog = false; assignTicketToAdmin()"
              style="cursor: pointer;"
            >
              <v-list-item-content>
                <v-list-item-title>{{ item.label }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
        </v-list>
      </v-card-text>
      <v-card-text v-if="updateType === 'priority'">
        <v-list >
            <v-list-item
            v-for="(item, index) in priorityList"
            :key="index"
            @click="selectedPriority = item.key; assignAdminDialog = false; assignTicketToAdmin()"
            style="cursor: pointer;"
          >
            <v-list-item-content>
              <v-list-item-title>{{ item.label }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card-text>
    </v-card>
    </v-dialog>
    <v-dialog
        ref="dialog"
        v-model="modal"
        :return-value.sync="date"
        persistent
        width="290px"
      >
        <!-- <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="date"
            label="Picker in dialog"
            prepend-icon="mdi-calendar"
            readonly
            v-bind="attrs"
            v-on="on"
          ></v-text-field>
        </template> -->
        <v-date-picker
          v-model="date"
          scrollable
        >
          <v-spacer></v-spacer>
          <v-btn
            text
            color="primary"
            @click="modal = false"
          >
            Cancel
          </v-btn>
          <v-btn
            text
            color="primary"
            @click="$refs.dialog.save(date); updateType = 'deadline'; assignTicketToAdmin();"
          >
            OK
          </v-btn>
        </v-date-picker>
      </v-dialog>
      <v-dialog
      v-model="supportDialog"
      persistent
      max-width="600px"
    >
      <v-card v-if="ticketData">
        <v-card-title>
          <v-row class="w-100 ma-0">
            <v-col cols="8" class="pa-0">
              <span class="text-h5">Ticket Id - {{ ticketData.ticket_id }}</span>
            </v-col>
            <v-col cols="4" class="pa-0 text-right">
              <v-btn
                color="primary"
                icon
                @click="supportDialog = false"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-col>
            </v-row>
          
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col style="padding: 6px 12px;" cols="3">
               Subject:
              </v-col>
              <v-col style="padding: 6px 12px;" cols="9" class="font-weight-bold">
                {{ ticketData.subject }}
              </v-col>
              <v-col style="padding: 6px 12px;" cols="3">
               Description:
              </v-col>
              <v-col style="padding: 6px 12px;" cols="9" class="font-weight-bold">
                {{ ticketData.description }}
              </v-col>
              <v-col style="padding: 6px 12px;" cols="3">
                Created:
              </v-col>
              <v-col style="padding: 6px 12px;" cols="9" class="font-weight-bold">
                {{ moment(ticketData.created_at).format('DD MMM YYYY') }}
              </v-col>
              <v-col style="padding: 6px 12px;" cols="3">
                Created By:
              </v-col>
              <v-col style="padding: 6px 12px;" cols="9" class="font-weight-bold">
                {{ ticketData.created_by_name }} ({{ ticketData.created_by_email }})
              </v-col>
              <v-col style="padding: 6px 12px;" cols="3">
                Company:
              </v-col>
              <v-col style="padding: 6px 12px;" cols="9" class="font-weight-bold">
                {{ ticketData.company }}
              </v-col>
              <v-col style="padding: 6px 12px;" cols="12">
                <span v-if="ticketData.attachments">Attachment:</span>
                <span v-else-if="ticketData.extra_data && Object.keys(ticketData.extra_data).length">Payload:</span>
              </v-col>
              <v-col style="padding: 6px 12px;" cols="12" v-if="ticketData.attachments">
                <img @click="attachmentDialog = true;" style="width:100%; cursor: pointer;" :src="ticketData.attachments" alt="" srcset="">
              </v-col>
              <v-col style="padding: 6px 12px;" cols="12" v-else-if="ticketData.extra_data && Object.keys(ticketData.extra_data).length">
                <span v-for="(value, key) in ticketData.extra_data" :key="key">
                  <strong>{{ key }}:</strong> {{ value }} <br>
                </span>
              </v-col>
              
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="supportDialog = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="attachmentDialog"
      fullscreen
    >
      <v-card>
        <v-card-title class="text-right" style="float: right;">
          <v-btn
            color="primary"
            text
            @click="attachmentDialog = false"
          >
            Close
          </v-btn>
        </v-card-title>
        <img v-if="ticketData && ticketData.attachments" style="width:100%;" :src="ticketData.attachments" alt="" srcset="">
        </v-card>
        </v-dialog>
    <v-dialog
      v-model="closeAdminNotificationDialog"
      persistent
      max-width="600px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Close Admin Notification</span>
        </v-card-title>
        <v-card-text>
          Are you sure you want to close the admin notification?<br>
          <v-switch
            v-model="notifyAdminCheckbox"
            inset
            label="Notify admin via email"
          ></v-switch>

          <label v-if="notifyAdminCheckbox">Body*</label>
    <quill-editor v-if="notifyAdminCheckbox"
      @focus="onEditorFocus($event)"
      @change="onEditorChange($event)"
      ref="myQuillEditor"
      class="quill-editor-1"
      name="body"
      data-vv-as="description"
      v-model="emailContent"
      :options="editorOption"
    >
      <div id="toolbar" slot="toolbar" style="border-radius: 8px 8px 0 0;">
        <button class="ql-bold">Bold</button>
        <button class="ql-italic">Italic</button>
        <button class="ql-underline">Underline</button>
        <button class="ql-strike">Strike</button>
        <button class="ql-header" value="1">Header 1</button>
        <button class="ql-header" value="2">Header 2</button>
        <button class="ql-blockquote">Blockquote</button>
        <button class="ql-list" value="ordered">Ordered List</button>
        <button class="ql-list" value="bullet">Bullet List</button>
        <button class="ql-code-block">Code</button>
        <button class="ql-link">Link</button>
        <button class="ql-image">Image</button>
      </div>
    </quill-editor>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            text
            @click="closeAdminNotification()"
          >
            Cancel
          </v-btn>
          <v-btn
            color="primary"
            @click="notifyAdmin = 'No';assignTicketToAdmin()"
          >
            Change status
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
/* eslint-disable */
var count = 0;
import * as am4core from "@amcharts/amcharts4/core";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import axios from 'axios';
import { mapState } from 'vuex';
import 'quill/dist/quill.bubble.css';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import { quillEditor } from 'vue-quill-editor';

import moment from 'moment';
import infiniteScroll from 'vue-infinite-scroll';
import addCompany from './dialogs/AddCompany';
import { assign, update } from "lodash";


am4core.useTheme(am4themes_animated);
export default {
  name: "TicketTable",

  components: {
    axios,
    infiniteScroll,
    addCompany,
    quillEditor
  },

  data: () => ({
    attachmentDialog: false,
    ticketData: null,
    selectedFilterStatus: '',
    selectedFilterPriority: '',
    emailContent: '',
    notifyAdminCheckbox: false,
    notifyAdmin: '',
    supportDialog: false,
    editorOption: {
          modules: {
            toolbar: '#toolbar'
          },
          placeholder: 'Type here ...'
        },
    pagination: {
        rowsPerPage: 10,
        page: 1,
        length: 1,
        totalLength: null
      },
    statusList: [
      { key: 'open', label: 'Open' },
      { key: 'in_progress', label: 'In progress' },
      { key: 'closed', label: 'Closed' },
      { key: 'reopened', label: 'Reopened' },
      { key: 'response_awaited', label: 'Response awaited' }
    ],
    adminList: ['rajat@amara.ai', 'amit.kumar@amara.ai', 'manjot.singh@amara.ai', ''],
    selectedFilterAssignedTo: '',
    priorityList: [
      { key: 'low', label: 'Low' },
      { key: 'medium', label: 'Medium' },
      { key: 'high', label: 'High' },
      { key: 'urgent', label: 'Urgent' }
    ],
    assignAdminDialog: false,
    modal: false,
    date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
    updateType: 'status',
    selectedAdmin: '',
    selectedStatus: '',
    selectedPriority: '',
    ticketId: '',
    headers: [
        { text: "S. No", value: "index", sortable: false, width: 70 },
        { text: "Ticket ID", value: "ticketId", sortable: false },
        { text: "Name", value: "name", sortable: false },
        { text: "Email", value: "email", sortable: false },
        { text: "Subject", value: "subject", sortable: false },
        { text: "Category", value: "category", sortable: false },
        { text: "Status", value: "status", sortable: false },
        { text: "Priority", value: "priority", sortable: false },
        { text: "Created", value: "created", sortable: false }
      ],

      tickets: [],
    drawerOpen: false,
    filtersMenu: false,
    moment: moment,
    data: [],
    loading: false,
    avatarList: [],
    busy: false,
    searchCompany: '',
    filter_status: null,
    filter_type: null,
    dashboardData: null,
  }),
  watch : {
    searchCompany: {
      deep: true,
      handler () {
        if (this.time) {
          clearTimeout(this.time);
        }
        this.time = setTimeout(() => this.getCompanyDetails(this.searchCompany), 1000);
      }
    }
  },
  computed: {
    badgeCount() {
    return (this.selectedFilterStatus && this.selectedFilterPriority) ? 2 : (this.selectedFilterPriority || this.selectedFilterStatus) ? 1 : null;
  },
    ...mapState({
      drawerOpen: state => state.drawerOpen, 
      snackbar: state => state.snackbar,
      user: state => state.user
    })
  },
  methods: {
    viewData(ticket) {
      this.supportDialog = true;
      this.ticketData = ticket;
    },
    getPriorityColor (priority) {
    return {
      low: '#22C55E',
      medium: '#3B82F6',
      high: '#F59E0B',
      urgent: '#EF4444'
    }[priority]
  },
  getStatusColor (status) {
    return {
      open: '#e0e0e0',
      in_progress: '#669df1',
      closed: '#10b981',
      response_awaited: '#f06548',
      reopened: '#f59e0b'
    }[status]
  },
  validatePage () {
      this.getAllTickets();
      // if (this.pagination.page < 1) this.pagination.page = 1;
      // if (this.pagination.page > this.pagination.length) this.pagination.page = this.pagination.length;
    },
    changeRowsPerPage () {
      this.pagination.page = 1;
      this.getAllTickets();
    },
    getAllTickets () {
    //   const queryParams = {
    //     count: 'true',
    //     page_limit: this.pagination.rowsPerPage,
    //     page_offset: this.pagination.page || 1,
    //     raw_search_string: searchString
    //   };
      axios.post(`${process.env.VUE_APP_API_URL_NEW}support/ticket/list`, {
        count: 'true',
        admin_request: true,
        fields: 'ticket_id,attachments,priority,extra_data,phone_number,ticket_source,ticket_type,subject,description,created_by_name,created_by_email,company,user,deadline,status,created_at,updated_at,assigned_to_email',
        page_limit: this.pagination.rowsPerPage,
        page_offset: this.pagination.page || 1,
        filters: {
          status: this.selectedFilterStatus ? this.selectedFilterStatus : undefined,
          priority: this.selectedFilterPriority ? this.selectedFilterPriority : undefined,
        },

      }, {
        withCredentials: true
      }).then((response) => {
        if (response && response.data) {
          this.tickets = response.data.data;
          this.pagination.length = Math.ceil(response.data.total_count / this.pagination.rowsPerPage);
          // this.pagination.page = 1;
          this.$forceUpdate();
        }
      }, (response) => {
        this.table.loading = false;
        this.config.initialLoading = false;
        this.$store.dispatch('updateSnackbar', {
          color: 'error',
          show: true,
          text: 'Unable to fetch tickets, Please try again later!'
        });
        throw new Error(response);
      });
    },
    closeAdminNotification () {
      this.closeAdminNotificationDialog = false;
      this.emailContent = '';
      this.notifyAdminCheckbox = false;
      this.notifyAdmin = '';
      this.$forceUpdate();
    },
    assignTicketToAdmin () {
      if (this.notifyAdminCheckbox) {
        this.notifyAdmin = 'Yes';
      }
      if (this.selectedStatus === 'closed' && !this.notifyAdmin) {
        this.$swal({
          title: 'Send email notification?',
          text: 'Do you want to send an email notification before closing this ticket?',
          icon: 'warning',
          showCancelButton: true,
          cancelButtonText: 'No, just close it!',
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, send it!'
        }).then((result) => {
          if (result.isConfirmed) {
            axios.patch(`${process.env.VUE_APP_API_URL_NEW}support/ticket/update/${this.ticketId}`, {
            status: this.updateType === 'status' ? this.selectedStatus : undefined,
            notify_user: true,
        }, {
            withCredentials: true
          }).then((response) => {
            if (response && response.data) {
              this.emailContent = '';
              this.selectedStatus = '';
              this.notifyAdminCheckbox = false;
              this.notifyAdmin = '';
              this.closeAdminNotificationDialog = false;
              this.$store.dispatch('updateSnackbar', {
                color: 'success',
                show: true,
                text: 'Ticket updated successfully!'
              });
              // this.tickets = response.data.data;
              this.getAllTickets();
            }
          }, (response) => {
            this.table.loading = false;
            this.config.initialLoading = false;
            this.$store.dispatch('updateSnackbar', {
              color: 'error',
              show: true,
              text: 'Unable to update tickets, Please try again later!'
            });
            throw new Error(response);
          });
          } else {
            axios.patch(`${process.env.VUE_APP_API_URL_NEW}support/ticket/update/${this.ticketId}`, {
            status: this.updateType === 'status' ? this.selectedStatus : undefined,
        }, {
            withCredentials: true
          }).then((response) => {
            if (response && response.data) {
              this.emailContent = '';
              this.notifyAdminCheckbox = false;
              this.notifyAdmin = '';
              this.selectedStatus = '';
              this.closeAdminNotificationDialog = false;
              this.$store.dispatch('updateSnackbar', {
                color: 'success',
                show: true,
                text: 'Ticket updated successfully!'
              });
              // this.tickets = response.data.data;
              this.getAllTickets();
            }
          }, (response) => {
            this.table.loading = false;
            this.config.initialLoading = false;
            this.$store.dispatch('updateSnackbar', {
              color: 'error',
              show: true,
              text: 'Unable to update tickets, Please try again later!'
            });
            throw new Error(response);
          });
          }
        });
        return;
      }
    //   const queryParams = {
    //     count: 'true',
    //     page_limit: this.pagination.rowsPerPage,
    //     page_offset: this.pagination.page || 1,
    //     raw_search_string: searchString
    //   };
    axios.patch(`${process.env.VUE_APP_API_URL_NEW}support/ticket/update/${this.ticketId}`, {
        assigned_to_email: this.updateType === 'assigned' ? this.selectedAdmin : undefined,
        priority: this.updateType === 'priority' ? this.selectedPriority : undefined,
        status: this.updateType === 'status' ? this.selectedStatus : undefined,
        deadline: this.updateType === 'deadline' ? this.date : undefined,
    }, {
        withCredentials: true
      }).then((response) => {
        if (response && response.data) {
          this.emailContent = '';
          this.notifyAdminCheckbox = false;
          this.notifyAdmin = '';
          this.closeAdminNotificationDialog = false;
          this.$store.dispatch('updateSnackbar', {
            color: 'success',
            show: true,
            text: 'Ticket updated successfully!'
          });
          // this.tickets = response.data.data;
          this.getAllTickets();
        }
      }, (response) => {
        this.table.loading = false;
        this.config.initialLoading = false;
        this.$store.dispatch('updateSnackbar', {
          color: 'error',
          show: true,
          text: 'Unable to update tickets, Please try again later!'
        });
        throw new Error(response);
      });
    },
    applyFilters() {
      this.drawerOpen = !this.drawerOpen;
      this.getAllTickets();
    },
      toggleDrawer() {
        this.drawerOpen = !this.drawerOpen;
      this.$store.dispatch('toggleDrawer');
    },
      resetFilters () {
        this.drawerOpen = !this.drawerOpen;
        this.selectedFilterStatus=null;
      this.selectedFilterPriority=null;
      this.getAllTickets();
    },
    logout () {
    axios.post(`${process.env.VUE_APP_API_URL}logout`, {}, {
      withCredentials: true
    }).then((response) => {
      if (response && response.data.status === 200) {
        this.$store.dispatch('deleteSession', 'logout');
        this.$router.push('/login');
      } else {
        this.$notify({
          group: 'foo',
          title: 'Error while logging out!',
          type: 'warn'
        });
        this.$store.dispatch('deleteSession', 'logout');
        this.$router.push('/login');
      }
    }, () => {
      this.$store.dispatch('deleteSession', 'logout');
      this.$router.push('/login');
    });
  },
  changeTab(url) {
    const queryParams = {};
    if (this.filter_type) {
      queryParams.filter_type = this.filter_type;
    }
    if (this.filter_status) {
      queryParams.filter_status = this.filter_status;
    }
    if (url === 'company-list') {
      queryParams.page = 1; 
    }
    this.$router.push({ path: `/${url}`, query: queryParams });
  },
    scrollToElement() {
  const el = this.$refs.scrollToMe;

  if (el) {
    el.scrollIntoView({behavior: 'smooth'});
  }
},
    openDetails (item) {
      this.$router.push(`/company-details?cid=${item.id}&page=${this.pagination.page}`);
    },
    applyFilter (data) {
      this.filter_type = data;
      this.getCompanyDetails();
      this.scrollToElement();
    },
    getAvatar () {
      // axios.defaults.headers.common.Authorization = `JWT ${this.user.access_token}`;
      axios.get(`${process.env.VUE_APP_API_URL}company/avatar`, {
        withCredentials: true
      }).then((response) => {
        if (response && response.data) {
          this.avatarList = response.data;
        }
      }).catch((err) => {
        if (err.response.status === 429) {
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: err.response.data.error
          });
        } else {
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: 'Unable to fetch details, Please try again later!'
          });
        }
      });
    },
    openModal () {
      this.$refs.addcompany.dialog = true;
      this.$refs.addcompany.company = {};
      this.$refs.addcompany.company.company_avatar = '';
      this.$refs.addcompany.company.company_avatar_id = '';
      this.$refs.addcompany.company.companies_avatar = this.avatarList;
      this.$refs.addcompany.company.is_active = true;
      this.$refs.addcompany.company.chat_cobranding_enabled = false;
      this.$refs.addcompany.company.allow_stage_edit = false;
    },
    loadMore() {
    this.busy = true;

      setTimeout(() => {
        for (var i = 0, j = 10; i < j; i++) {
          this.data.push({ name: count++ });
        }
        this.busy = false;
      }, 1000);
    },
    editCompany (data) {
      this.$router.push(`/company-details?cid=${data.id}&editview=true&page=${this.pagination.page}`);
    },
  },
  mounted () {
    this.getAllTickets();
    if (!this.user.email) {
      this.$router.push(`/login`);
    }
  }
}
</script>
<style lang="scss" >
.filterDrawer .v-icon.v-icon {
  font-size: 14px !important;
}
.filterDrawer .v-input--selection-controls {
  margin-top: 0px !important;
}
.heading {
  font-size: 16px;
  padding-top:10px;
}
.dashboardCount {
  font-size: 70px;
  padding:10%;
}

.mainBox {
      background-color: white;
    border-radius: 6px;
    box-shadow: 0 4px 16px 11px rgb(0 0 0 / 6%), 0 4px 8px rgb(0 0 0 / 10%) !important;
    height: 16rem;
    transition: 0.5s;
    -webkit-transition: 0.5s;
    text-align: center;
}
.v-btn--active {
    background-color: #050550 !important;
  }
.disabledView {
  .v-btn--active {
    background-color: #858585 !important;
  }
}
#chartdiv1 {
  height: 400px;
  width:100%;;
}

.primary--text {
  color: #050550 !important;
}
#chartdiv {
  width: 100%;
  height: 210px;
  
}
.headingprofile {
  text-align: left;
  h2 {
        color: #263238;
    
    // font-family: Montserrat;
    font-weight: 500;
    line-height: 1.1;
    font-size: 20px;
    margin: 0 0 6px;
    width: 100%;
  }
}
.logo-container {
    width: 100%; 
    height: 80px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.logo-container img {
    width: 100%;
    height: 100%;
    object-fit: contain; 
}
.v-card__text {
  padding-top:0px;
}
.searchEmployee.v-text-field--outlined fieldset {
  border-style: none !important;
}
.sticky-header {
  position: sticky;
  top: 63px; 
  z-index: 10; 
  background-color: #f6f6f8;
}
.sticky-header1 {
  position: sticky;
  top: 125px; 
  z-index: 10; 
  background-color: #f6f6f8;
}
.filterButton {
  box-shadow: none !important;
    color: #10b981 !important;
    background: #daf4f0 !important;
    border-color: transparent;
}
.filterButton:hover {
  box-shadow: none !important;
  color: white !important;
  background: #10b981 !important;
  border-color: transparent !important;
}
.filterBadge {
  transition: transform 0.3s ease;
}

.shakeAnimation {
  animation: shake 0.5s ease-in-out infinite;
}

@keyframes shake {
  0%, 100% { transform: translateX(0); }
  25% { transform: translateX(-5px); }
  50% { transform: translateX(5px); }
  75% { transform: translateX(-5px); }
}

.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) > .v-input__control > .v-input__slot {
  box-shadow: none !important;
}
.v-menu__content {
  z-index: 999 !important;
}
.v-btn-toggle--group > .v-btn.v-btn {
  margin-left: 0px !important;
  margin-right:0px !important;
  border-color: #d7d7d7 !important;
}
.v-btn-toggle > .v-btn.v-btn--active {
  background-color: #10b981 !important;
  color: white !important;
}
.hover:hover {
  background-color: #10b981;
    color: white;
    position: relative;
    text-align: center;
    padding: 10px;
}
.hover:hover::after {
  content: "";
  position: absolute;
  bottom: -6px;
  left: 50%;
  transform: translateX(-50%) rotate(45deg);
  width: 12px;
  height: 12px;
  background-color: #10b981;
}
.toggleButton {
    text-transform: capitalize; 
}
.ticket-card {
  border-radius: 16px;
  overflow: hidden;
  background: #f7f6ff;
}

.table-title {
  font-weight: 600;
  font-size: 16px;
  color: #4a4a6a;
}

.ticket-table {
  background: #ffffff;
  font-size: 13px;
}

/* header */
.ticket-table >>> .v-datatable-header {
  background: #f5f3ff;
}

.ticket-table >>> th {
  color: #8c8cad;
  font-weight: 600 !important;
  font-size: 12px;
  border-bottom: none !important;
}

/* rows */
.ticket-table >>> tbody tr {
  border-bottom: 1px solid #f0efff;
}

.ticket-table >>> tbody tr:hover {
  background: #f9f8ff;
}

/* checkbox column */
.ticket-table >>> .v-input--selection-controls__ripple {
  margin-left: 4px;
}

/* generic text */
.col-text {
  color: #5b5b7c;
  font-size: 13px;
}

.index-col {
  font-weight: 600;
}

.email-col {
  opacity: 0.9;
}

.created-col {
  font-size: 12px;
  color: #9a9ab5;
}

/* Ticket link */
.ticket-link {
  color: #5f6bff;
  text-decoration: none;
  font-weight: 600;
  font-size: 13px;
}

/* Pills */
.pill {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 2px 10px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 600;
  text-transform: none;
}

/* light category pill */
.pill-soft {
  background: rgba(146, 154, 255, 0.12);
  color: #6c6fff;
}

/* status colors */
.pill-in-progress {
  background: rgba(255, 214, 150, 0.4);
  color: #f59e0b;
}

.pill-closed {
  background: rgba(167, 243, 208, 0.6);
  color: #059669;
}

.pill-on-hold {
  background: rgba(254, 202, 202, 0.6);
  color: #dc2626;
}
.am-table-title {
    font-size: 14px !important;
    line-height: 18px;
    color: var(--color-text);
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    font-weight: 500 !important;
}
.am-table-sub-title {
  font-size: 12px !important;
  line-height: 18px;
  color: #878a99;
  // text-overflow: ellipsis;
  // overflow: hidden;
  // white-space: nowrap;
  font-weight: 500 !important;
}
.truncate-text {
  display: inline-block;
  max-width: 250px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: middle;
}
.employee-lists {
      .table-wrapper {
        border-top: none !important;
        border-radius:6px;
        overflow-x: auto;
        width: 100%;
      }
      .emp-table tbody tr {
  background: white;
}
.emp-table th {
  background: #c5c5d8 !important;
}
    .emp-table {
      width: 100%;
       td {
        padding: 6px 3px 3px 6px ;
      }
      th {
        padding: 24px 12px 24px;
      }
      .sticky-col {
        position: sticky;
        background: #fff;
      }
      .sticky-col1 {
        position: sticky;
        background: #fff;
      }
      .emp-action-btn {
        box-shadow: none !important;
      }
      margin: 0px;
      position: relative;
      .emp-action {
        position: relative;
        display: flex;
        align-items: center;
        .emp-avatar {
          height: fit-content;
          margin: 0 12px;
          padding: 5px;
          border-radius: 100px;
          border: 1px solid #e9ebec;;
          background: var(--bg);
          margin: 0 12px;
        }
        .emp-checkbox,
        .emp-avatar {
          display: flex;
          position: relative;
          align-items: center;
        }
        .star-icon {
          position: absolute;
          top: 4px;
          left: -6px;
          i {
            color: #fdd835 !important;
            font-size: 20px !important;
          }
        }
        .emp-profile-image {
          width: 50px;
          height: 50px;
          img {
            border-radius: 50%;
            width: 100%;
            height: 100%;;
          }
        }
      }
      .emp-desc-wrap {
        overflow: hidden;
        .emp-desc {
          .emp-name {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            font-size: var(--content-size);
            color: var(--color-text);
          }
          .emp-department, .emp-email {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            font-size: var(--content-caption);
            color: var(--color-palceholder);
          }
        }
      }
      .emp-mood {
        img {
          width: 30px;
          height: 30px;
        }
      }
      .emp-sub {
        font-size: var(--content-caption);
        color: var(--color-palceholder);
      }
      .emp-resolution {
        text-transform: capitalize;
      }
      th.sticky-col {
        left: 0;
      }
      td.sticky-col {
        left: 0;
      }
      th.sticky-col1 {
        right: -1px;
        left: auto;
      }
      td.sticky-col1 {
        right: -1px;
        left: auto;
      }
    }
  }
  .ql-container {
    min-height: 150px !important;
  }
</style>